import React from 'react';
// eslint-disable-next-line import/namespace
import { Redirect } from 'react-router';

const MyFavoriteArticlesPageRedirect = () => (
  <Redirect to="/matvaror/mina-favoritvaror" />
);

export default MyFavoriteArticlesPageRedirect;
